import { PaymentMethod, createAndHydrateCalculator, defaultDraftCalculatorId as modalCalculatorId, hydrateFromCalculator, offersSelectionChanged, persistCalculatorToUrl, selectIncentiveOffers, selectLoyaltyOffer, selectPaymentMethod, } from '../../core/reducers/financialCalculators';
import { loyaltyPrimaryChanged, offersPrimaryChanged, selectSelectedOffers } from '../../core/reducers/offers';
import { selectCurrentVehicleTransmissionKey } from '../../core/reducers/currentVehicle';
import { setIsPaymentCalculatorModalOpen } from '../../core/reducers/ui';
import { useAppDispatch, useAppSelector } from '../../core/utils';
const usePaymentCalculatorModal = (originalCalculatorId) => {
    const dispatch = useAppDispatch();
    const isModalOpen = useAppSelector(state => state.ui.SummaryBar.isPaymentCalculatorModalOpen);
    const transmissionKey = useAppSelector(selectCurrentVehicleTransmissionKey);
    const paymentMethod = useAppSelector(state => selectPaymentMethod(state, modalCalculatorId));
    const selectedPrimaryOffers = useAppSelector(state => selectSelectedOffers(state, transmissionKey, paymentMethod || PaymentMethod.lease));
    const selectedIncentiveOffers = useAppSelector(state => selectIncentiveOffers(state, modalCalculatorId));
    const selectedLoyaltyOffer = useAppSelector(state => selectLoyaltyOffer(state, modalCalculatorId));
    const openModal = () => {
        dispatch(createAndHydrateCalculator(originalCalculatorId, modalCalculatorId));
        dispatch(setIsPaymentCalculatorModalOpen(true));
    };
    const closeModal = () => {
        dispatch(setIsPaymentCalculatorModalOpen(false));
    };
    const submitModalForm = () => {
        dispatch(hydrateFromCalculator({
            sourceId: modalCalculatorId,
            destinationId: originalCalculatorId,
            offerIds: selectedPrimaryOffers.incentive,
            loyaltyOffer: selectedPrimaryOffers.loyalty,
        }));
        dispatch(offersSelectionChanged({
            calculatorId: originalCalculatorId,
            offerIds: selectedIncentiveOffers || [],
        }));
        dispatch(offersPrimaryChanged({
            calculatorId: originalCalculatorId,
            offerIds: selectedIncentiveOffers || [],
            transmissionKey,
            paymentMethod: paymentMethod || PaymentMethod.lease,
        }));
        dispatch(loyaltyPrimaryChanged({
            calculatorId: originalCalculatorId,
            offerKey: selectedLoyaltyOffer || '',
            transmissionKey,
            paymentMethod: paymentMethod || PaymentMethod.lease,
        }));
        dispatch(persistCalculatorToUrl(originalCalculatorId));
        closeModal();
    };
    return {
        modalCalculatorId,
        isModalOpen,
        openModal,
        closeModal,
        submitModalForm,
    };
};
export default usePaymentCalculatorModal;
